import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import Numeral from 'numeral'

import { reportInterval, ownerName, monthlyStatementData, priorBalance, currentBalance } from 'selectors/reports'
import { properties } from 'selectors/entities'

let select = state => ({
	ownerName: ownerName(state)
  , period: reportInterval(state)
  , monthlyStatement: monthlyStatementData(state)
  , priorBalance: priorBalance(state)
  , currentBalance: currentBalance(state)
  , properties: properties(state)
})

export class MonthlyStatement extends Component{
	render(){
		let { props } = this
		let monthlyStatement = props.monthlyStatement
		let sortedProperties = R.pipe(R.values, R.sortBy(R.prop('alias')))(props.properties)
		console.log(monthlyStatement);
		return(
			<div style={{width: "50%", margin: "0 auto"}} >
				<div id="finance-report">
					<div className="header" style={{display: "inline-block", width: "100%", margin: "50px 0"}}>
						<div
							className="logo-container"
							style={{
								display: "inline-block"
							  , float: "left"
							}}
						>
							<img src="/landlord/static/img/bot-logo.png" alt="logo" width="100" />
						</div>
						<div
							className="meta"
							style={{
								display: "inline-block"
							  , float: "right"
							  , textAlign: "right"
							}}
						>
							<h4 style={{margin: "0"}}>{props.ownerName}</h4>
							<h5 style={{margin: "0"}}>{"from " + props.period.from + " to " + props.period.to}</h5>
						</div>
					</div>
					<div style={{display: "flex", justifyContent: "space-between", margin: "15px 0"}}>
						<div>
							Prior balance
						</div>
						<div>
							$ {Numeral(props.priorBalance.total).format('0,0')}
						</div>
					</div>
					<div style={{margin: "30px 0"}}>
						{
							R.map(netIncome => (
								<div style={{display: "flex", justifyContent: "space-between", margin: "15px 0"}}>
									<div style={{fontWeight: netIncome.propertyAlias == 'Total'? "bold" : "normal"}}>
										{netIncome.propertyAlias}
									</div>
									<div style={{fontWeight: netIncome.propertyAlias == 'Total'? "bold" : "normal"}}>
										$ {Numeral(netIncome.amount).format('0,0')}
									</div>
								</div>
							))(monthlyStatement.netIncome)
						}
					</div>
					<div style={{display: "flex", justifyContent: "space-between", margin: "15px 0"}}>
						<div style={{fontWeight: "bold"}}>
							Paid to landlord
						</div>
						<div style={{fontWeight: "bold"}}>
							$ {Numeral(0).format('0,0')}
						</div>
					</div>
					<div style={{display: "flex", justifyContent: "space-between", margin: "15px 0"}}>
						<div>
							Current balance
						</div>
						<div>
							$ {Numeral(props.currentBalance.total).format('0,0')}
						</div>
					</div>
					 {
						 R.map((property) => {
							let rentIncome = R.filter(x => x.propertyAlias == property.alias)(props.monthlyStatement.rentIncome)[0]
							let expenses = R.filter(x => x.propertyAlias == property.alias)(props.monthlyStatement.expenses)[0]
							let netIncome = R.filter(x => x.propertyAlias == property.alias)(props.monthlyStatement.netIncome)[0]
							return (
							<div>
								<div className="html2pdf__page-break"></div>
								<div className="header" style={{display: "inline-block", width: "100%", margin: "50px 0"}}>
									<div
										className="logo-container"
										style={{
											display: "inline-block"
										  , float: "left"
										}}
									>
										<img src="/landlord/static/img/bot-logo.png" alt="logo" width="100" />
									</div>
									<div
										className="meta"
										style={{
											display: "inline-block"
										  , float: "right"
										  , textAlign: "right"
										}}
									>
										<h4 style={{margin: "0"}}>{props.ownerName + ": " + property.alias}</h4>
										<h5 style={{margin: "0"}}>{"from " + props.period.from + " to " + props.period.to}</h5>
									</div>
								</div>
								<div style={{display: "flex", justifyContent: "space-between", margin: "15px 0"}}>
			 						<div>
			 							Rent income
			 						</div>
			 						<div>
			 							$ {Numeral(rentIncome && rentIncome.amount).format('0,0')}
			 						</div>
									</div>
								<div style={{display: "flex", justifyContent: "space-between", margin: "15px 0"}}>
									<div>
										Expenses
									</div>
									<div>
										$ {Numeral(expenses && expenses.amount.total).format('0,0')}
									</div>
								</div>
								{
									R.values(R.mapObjIndexed(line => (
										<div style={{display: "flex", justifyContent: "space-between", margin: "10px 0 10px 30px", fontSize: "14px"}}>
											<div>
												{line.category}
											</div>
											<div>
												$ {Numeral(line.amount).format('0,0')}
											</div>
										</div>
									))(expenses && expenses.amount.categories))
								}
								<div style={{display: "flex", justifyContent: "space-between", margin: "15px 0"}}>
			 						<div style={{fontWeight: "bold"}}>
			 							Net income
			 						</div>
			 						<div style={{fontWeight: "bold"}}>
			 							$ {Numeral(netIncome && netIncome.amount).format('0,0')}
			 						</div>
									</div>
							</div>
						)}, sortedProperties)
					 }
				</div>
			</div>
		)
	}
}

export default connect(select)(MonthlyStatement)



// WEBPACK FOOTER //
// ./src/routes/landlord/finances/Report/MonthlyStatement.js